/**
 * Accesso al modulo Centro Diurno — attivato dal super-admin per organizzazione.
 */
export function canAccessCentroDiurno(user) {
  if (!user) return false;
  return Boolean(user.centro_diurno_enabled);
}
